/* istanbul ignore file */
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import frLocale from 'date-fns/locale/fr';
import { Grid, TextField } from '@material-ui/core';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { DATE_PICKET_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import { INVOICE_INFO } from 'containers/data-structure';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import WarningCard from 'components/InvoiceFeeNoteDialog/WarningCard';
import { translate } from 'containers/services/translate';
import messages from 'components/InvoiceFeeNoteDialog/messages';
import { getDocumentId } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { compareDate } from 'containers/CourtManagerLegalProceedings/AssignExpert/utils';

export interface InvoiceFeeNotesManagerDialogProps {
  intl: IntlShape;
  listings: any;
  invoiceFeeNoteInfo: any;
  invoiceFeeNoteInfos: any;
  resetUploadedDocument: Function;
  uploadedDocument: any;
  uploadDocument: Function;
  assignedLawyersByJudiciaryProcess: any;
  setDocumentId: Function;
  setInvoiceFeeNoteInfo: Function;
  displayFirmReferenceInput: boolean;
  documentId?: any;
  index: any;
  limitInvoiceDate?: any;
}

const InvoiceFeeNotesManagerDialog: React.FC<InvoiceFeeNotesManagerDialogProps> = (
  props,
): JSX.Element => {
  const [infoInvoice, setInfoInvoice] = useState({});
  useEffect(() => {
    setInfoInvoice({ ...props.invoiceFeeNoteInfos[props.index] });
  }, [props.invoiceFeeNoteInfos]);

  const handleInvoiceDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    props.invoiceFeeNoteInfos[props.index][INVOICE_INFO.INVOICE_DATE] = moment(
      theDate as Date,
    ).format();

    props.setInvoiceFeeNoteInfo(props.invoiceFeeNoteInfos);
    setInfoInvoice({
      ...infoInvoice,
      [INVOICE_INFO.INVOICE_DATE]: moment(theDate as Date).format(),
    });
    return;
  };
  const handleReceptionDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);

    props.invoiceFeeNoteInfos[props.index][
      INVOICE_INFO.INVOICE_RECEPTION_DATE
    ] = moment(theDate as Date).format();
    setInfoInvoice({
      ...infoInvoice,
      [INVOICE_INFO.INVOICE_RECEPTION_DATE]: moment(theDate as Date).format(),
    });
    props.setInvoiceFeeNoteInfo(props.invoiceFeeNoteInfos);
    return;
  };
  const handleSetDocument = (index: number) => (value: any) => {
    if (String(props.documentId) === getDocumentId(index)) {
      props.invoiceFeeNoteInfos[index]['url'] = get(value, 'url', null);
      props.invoiceFeeNoteInfos[index]['name'] = get(value, 'name', null);
      props.invoiceFeeNoteInfos[index]['type'] = get(value, 'type', null);
      props.setInvoiceFeeNoteInfo(props.invoiceFeeNoteInfos);
    }
    props.resetUploadedDocument();
  };
  const handleChange = (field: string, index: number) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;

    switch (field) {
      case INVOICE_INFO.INVOICE_NUMBER:
        props.invoiceFeeNoteInfos[index][INVOICE_INFO.INVOICE_NUMBER] = value;
        break;
      case 'firmReference':
        props.invoiceFeeNoteInfos[index]['firmReference'] = value;
        break;

      default:
        return props.invoiceFeeNoteInfos;
    }
    props.setInvoiceFeeNoteInfo(props.invoiceFeeNoteInfos);
  };

  return (
    <>
      {compareDate(
        moment().format('YYYY-MM-DD'),
        get(infoInvoice, 'invoiceDate', null),
      ) >= props.limitInvoiceDate &&
        featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) && (
          <WarningCard
            message={translate(messages.warningInvoiceDateManager, props, {
              limitDaysManager: props.limitInvoiceDate,
            })}
          />
        )}
      <Grid container direction="row" spacing={3} style={{ marginTop: 5 }}>
        {props.displayFirmReferenceInput && (
          <Grid item xs={6}>
            <TextField
              label={translate(messages.firmReference, props)}
              name={'firmReference'}
              value={get(infoInvoice, 'firmReference', null) as any}
              fullWidth
              onChange={handleChange('firmReference', props.index)}
            />
          </Grid>
        )}
        <Grid item xs={6}>
          <TextField
            label={translate(messages.invoiceNumberField, props)}
            name={INVOICE_INFO.INVOICE_NUMBER}
            value={get(infoInvoice, 'invoiceNumber', null) as any}
            fullWidth
            onChange={handleChange(INVOICE_INFO.INVOICE_NUMBER, props.index)}
          />
        </Grid>
        <Grid item xs={6}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              format={DATE_PICKET_FORMAT}
              id={INVOICE_INFO.INVOICE_DATE}
              fullWidth
              name={INVOICE_INFO.INVOICE_DATE}
              onChange={handleInvoiceDateChange}
              value={dateStringToLocalDate(
                get(infoInvoice, 'invoiceDate', null) as any,
              )}
              label={translate(messages.invoiceDateField, props)}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid xs={6} style={{ marginTop: 15 }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              format={DATE_PICKET_FORMAT}
              id={INVOICE_INFO.INVOICE_RECEPTION_DATE}
              name={INVOICE_INFO.INVOICE_RECEPTION_DATE}
              fullWidth
              onChange={handleReceptionDateChange}
              value={dateStringToLocalDate(
                get(infoInvoice, 'receptionDate', null) as any,
              )}
              label={translate(messages.invoiceReceptionDateField, props)}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>

      <Grid xs={6} style={{ marginTop: 20 }}>
        <UploadDocumentBloc
          index={props.index}
          document={{
            url: get(props.invoiceFeeNoteInfos[props.index], 'url', null),
            name: get(props.invoiceFeeNoteInfos[props.index], 'name', null),
            type: get(props.invoiceFeeNoteInfos[props.index], 'type', null),
          }}
          setDocument={handleSetDocument(props.index)}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          docType={DOCUMENT_TYPES.INVOICE_DOCUMENT}
          setDocumentId={props.setDocumentId}
          docId={getDocumentId(props.index)}
        />
      </Grid>
    </>
  );
};
export default injectIntl(InvoiceFeeNotesManagerDialog);
